import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import { devConfig } from 'config/config'; // Importing development configuration
import { profile } from 'config/config'; // Importing user profile configuration
import 'webix/photo'; // Importing Webix photo component
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

/**
 * Class representing the filter deposit reports view.
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const fecha = {
            // Configuration for date input fields
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for datepicker
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                },
                {
                    view: 'datepicker', // Datepicker component
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    value: moment().format('YYYY-MM-DD'), // Default date value
                    format: '%d %M %Y', // Date format
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Maximum selectable date
                        },
                    },
                },
            ],
        };
        const transactionId = {
            // Configuration for transaction ID input
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for transaction ID
                    name: 'TransactionId',
                    type: 'number',
                    label: _('Transacción ID'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Transacción ID'), // Localized placeholder
                    invalidMessage: _('Transacción ID is required'), // Validation message
                },
            ],
        };
        const upper_section = {
            // Upper section layout containing filters
            id: 'a1',
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 130 : 0, // Responsive height
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [fecha, transactionId], // Columns for date and transaction ID
                },
            ],
        };
        const buttons = {
            // Configuration for action buttons
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Localized button text
                    autowidth: true,
                    click: () => {
                        // Clear form on click
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Localized button text
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Handle consult action
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('depositReport:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const accordion_section = {
            // Accordion section for filters
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Localized header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            // Configuration for second set of action buttons
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button for second form
                    value: _('Limpiar'), // Localized button text
                    width: 100,
                    click: () => {
                        $$('myForm2').clear(); // Clear second form
                    },
                },
                {
                    view: 'button', // Consult button for second form
                    value: _('Consultar'), // Localized button text
                    type: 'form',
                    width: 110,
                    click: () => {
                        // Handle consult action for second form
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('depositReport:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                    },
                },
            ],
        };
        const accordion_section3 = {
            // Accordion section for second form
            padding: 10,
            rows: [upper_section, buttons2], // Include upper section and second set of buttons
        };
        const accordion_section2 = {
            // Accordion section for filters
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Localized header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Localized label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // ID for the second form
                type: 'clean',
                rows: [accordion_section3], // Include accordion section
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            // Return the main form configuration
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }
    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Placeholder for potential future logic
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if typeDate is not 2
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input if typeDate is 2
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
